
import { Base } from '../base-component';

import './feature-badge.component.scss';

export class FeatureBadge extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/feature-badge/feature-badge.component.ts